import { render, staticRenderFns } from "./QuickAppointmentForm.vue?vue&type=template&id=959888a0&scoped=true&"
import script from "./QuickAppointmentForm.vue?vue&type=script&lang=js&"
export * from "./QuickAppointmentForm.vue?vue&type=script&lang=js&"
import style0 from "./QuickAppointmentForm.vue?vue&type=style&index=0&id=959888a0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "959888a0",
  null
  
)

export default component.exports